import { useStudiesCopy } from "@/features/i18n/studiesCopy";
import { requireTab } from "@/features/navigation/requireTab";
import { useNav } from "@/utils/nav";
import { Outlet, createFileRoute } from "@tanstack/react-router";

function StudiesLayout() {
    const copy = useStudiesCopy();
    useNav([{ route: { to: "/studies" }, label: copy.studies }]);

    return <Outlet />;
}

export const Route = createFileRoute("/_app/studies")({
    beforeLoad: ({ context }) => requireTab(context, "studies"),
    component: StudiesLayout,
});
